import { CanActivateFn } from '@angular/router';
import { hasRoleGuard } from './role.guard';
import { Role } from './models/role';

/**
 * Guards the /admin back-office subtree. Applied once at the subtree root so
 * every admin child route inherits it — new admin features need no guard of
 * their own. Kept as a named alias (not an inline hasRoleGuard call at the
 * route) so the "what makes a route admin-only" rule lives in one place.
 */
export const AdminGuard: CanActivateFn = hasRoleGuard(Role.SUPER_ADMIN);
